import { Div, Grid } from '@fastnorth/kraken/components/layout';
import { Button } from '@fastnorth/kraken/components/button';
import { Text } from '@fastnorth/kraken/components/typography';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
import { useApp } from '../../hooks/AppProvider';
import { type ReactElement, useState } from 'react';
import type { RelatedEvent } from '../../types/events.ts';

const ResultsByYear = (): ReactElement | null => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.layout.side_menu' });
  const [{ event }] = useApp();
  const [expanded, setExpanded] = useState(false);

  if (!event) return null;

  if (!event?.relatedEvents || event?.relatedEvents?.length === 0) return null;

  const relatedEvents = event.relatedEvents;
  const sortedByYear = [...relatedEvents]
    .reduce<RelatedEvent[]>((acc, event): RelatedEvent[] => {
      const { eid, year } = event;

      // prefer larger EID if multiple events in the same year (shouldn't happen)
      if (acc[year] && eid < acc[year].eid) {
        return acc;
      }

      acc[year] = event;
      return acc;
    }, [])
    .flat()
    .sort((a, b) => b.year - a.year);

  return (
    <Div>
      <Button onClick={() => setExpanded(!expanded)} variant={expanded ? 'default' : 'outline'}>
        <Text modifier={'underline'}>{t('results_by_year')}</Text>
        {!expanded && <ChevronDownIcon className={'ml-3'} />}
        {expanded && <ChevronUpIcon className={'ml-3'} />}
      </Button>
      {expanded && (
        <Grid className={'mt-4 grid-cols-4 grid-auto-rows'}>
          {sortedByYear.map((relatedEvent) => (
            <Div key={relatedEvent.uuid}>
              <Button
                variant={'ghost'}
                onClick={() => window.location.assign(`${relatedEvent.resultsUrl}`)}>
                {relatedEvent.year}
              </Button>
            </Div>
          ))}
        </Grid>
      )}
    </Div>
  );
};

export default ResultsByYear;
